// extracted by mini-css-extract-plugin
export default {"container":"StandardsTable__container___dvrXQ"};